<template>
  <div class="GmzHqsjfx" v-loading = "loading">
    <div class="headerSearch">
      <div class="sousuo">
        <el-form
          ref="search"
          style="width: calc(100% - 225px)"
          :model="formInline"
          label-position="left"
          label-width="90px"
        >
          <el-row>
            <el-col :span="8">
              <el-form-item label="购买省份:">
                <el-select v-model="formInline.gmdwProvince" filterable placeholder="请选择">
                  <el-option
                    v-for="item in xzqhList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="销售省份:">
                <el-select v-model="formInline.xsdwProvince" filterable placeholder="请选择">
                  <el-option
                    v-for="item in xzqhList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="化学品名称:">
                <el-select v-model="formInline.hxpBms" filterable multiple placeholder="请选择(可多选)">
                  <el-option
                    v-for="item in hxpList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="核发时间:">
                <el-date-picker
                  v-model="formInline.beginHfrq"
                  style="width: 45%"
                  type="datetime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  placeholder="选择"
                />
                -
                <el-date-picker
                  v-model="formInline.endHfrq"
                  style="width: 45%"
                  type="datetime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  placeholder="选择"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="核准数量:">
                <el-input
                  style="width: 30%"
                  v-model="formInline.beginHzsl"
                  clearable
                  placeholder="请输入"
                />
                -
                <el-input
                  style="width: 30%"
                  v-model="formInline.endHzsl"
                  clearable
                  placeholder="请输入"
                />
                <el-select style="width: 27%" v-model="formInline.hzslDw" placeholder="请选择" clearble>
                  <el-option
                    v-for="item in sldwList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div style="width:225px">
          <el-button
            type="primary"
            icon="el-icon-search"
            round
            size="small"
            @click="handleCurrentChange(1)"
          >搜索</el-button>
          <el-button
            icon="el-icon-refresh-left"
            round
            size="small"
            @click="resetDataSource"
          >重置</el-button>
        </div>

      </div>
    </div>
    <div
      style="margin: auto;
        width: 95%;
        max-width: 1518px;
        background-color: white;
        padding-top: 40px;
        padding-bottom: 57px;"
    >
      <div class="tablemes">
        <div
          style="
            background-color: #f2f2f2;
            padding: 10px;
            border: 1px solid #f2f2f2;
          "
        >
          <el-button
            v-preventReClick
            icon="el-icon-upload2"
            size="mini"
            @click="dcexcel"
          >导出</el-button>
          <el-button
            v-preventReClick
            icon="el-icon-download"
            size="mini"
            type="primary"
            @click="addAllResult"
          >批量新增数据</el-button>
        </div>
        <el-table
          ref="gmzHqfxTabel"
          :data="tableData"
          border
          :show-overflow-tooltip="true"
          :header-cell-style="{ background: '#F2F2F2' }"
          style="width: 100%"
        >
          <el-table-column
            prop="xkzBh"
            label="购买证编号"
          />
          <el-table-column
            prop="hfrq"
            label="核发时间"
          />
          <el-table-column
            prop="hxpMc"
            label="化学品"
          />
          <el-table-column
            label="核准数量"
          >
            <template slot-scope="scope">
              {{ scope.row["hzsl"] +
                "  (" +
                scope.row["hzslDwLabel"] +
                ")" }}
            </template>
          </el-table-column>
          <el-table-column
            label="单价"
          >
            <template slot-scope="scope">
              {{ scope.row["dj"] +
                "  (" +
                scope.row["djDwLabel"] +
                ")" }}
            </template>
          </el-table-column>
          <el-table-column
            prop="gmdwProvinceLabel"
            label="购买单位省份"
          />
          <el-table-column
            prop="xsdwProvinceLabel"
            label="销售单位省份"
          />
        </el-table>
        <el-pagination
          background
          layout="prev,pager,next,jumper,total,sizes"
          :total="total"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="pagesize"
          :current-page.sync="currentPage"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { getXZQHList } from '@/assets/js/xzqh'
import { getGmzHqsjfxData, exportGmzHqsjfxData, addlistData, getHxpListByLevel4 } from '@/assets/js/gmzHqsjfx'
import {addSave, editSave} from "@/assets/js/tyshxydm";
export default {
  name: 'GmzHqsjfx',
  data() {
    return {
      loading: false,
      formInline: { // 搜索表单
        gmdwProvince: '',
        xsdwProvince: '',
        hxpBms: [],
        beginHfrq: '',
        endHfrq: '',
        beginHzsl: null,
        endHzsl: null,
        hzslDw: '1'

      },
      currentPage: 1, // 当前页
      pagesize: 10, // 每页的数据条数
      total: 0, // 列表总数
      tableData: [], // 表格数据
      xzqhList: [],
      hxpList: [],
      sldwList: [
        {
          label:'吨',
          value:'1',
        },
        {
          label:'千克/升',
          value:'2',
        },
        {
          label:'克/毫升',
          value:'3',
        }
      ],
    }
  },
  mounted() {
    getHxpListByLevel4().then(res => {
      this.hxpList = []
      if (res.status === 200 && res.data.code === '000000') {
        this.hxpList = res.data.data
      }
    })
    getXZQHList({
      param: {}
    }).then(res => {
      if (res.status === 200 && res.data.code === '000000') {
        this.xzqhList = []
        const sj = res.data.data
        sj.forEach((elem, index) => {
          const obj = { label: elem.areaName, value: elem.xzqhId }
          this.xzqhList.push(obj)
        })
      }
    })
    this.loadDatasource()
  },
  methods: {
    addAllResult(){
      this.$confirm('该操作会将满足查询条件的所有数据新增到行情数据表中，确定继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(() => {
        this.loading = true
        addlistData(this.formInline).then((e) => {
          console.log(e.data)
          this.$message.success(e.data.data)
          this.loading = false
        }).catch((e)=>{
          this.loading = false
        })
      })
    },
    dcexcel() {
      this.$message.info('正在导出中...')
      exportGmzHqsjfxData({
        param: this.formInline
      }).then((e) => {
        this.$message.success('导出成功!')
        const table = '行情数据分析'
        const a = document.createElement('a')
        const blob = new Blob([e.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'
        })
        const objectUrl = URL.createObjectURL(blob)
        a.setAttribute('href', objectUrl)
        a.setAttribute('download', table + '.xlsx')
        a.click()
      })
    },
    // 当前页码改变时
    handleCurrentChange(val) {
      this.currentPage = val // 当前页
      this.loadDatasource()
    },
    // 查询列表数据
    loadDatasource() {
      getGmzHqsjfxData({
        page: this.currentPage,
        size: this.pagesize,
        param: this.formInline
      }).then((e) => {
        this.tableData = e.data.data.rows
        this.total = e.data.data.total
      })
    },
    // 10条/页改变时
    handleSizeChange(val) {
      this.pagesize = val
      this.loadDatasource()
    },
    // 重置
    resetDataSource() {
      this.formInline = {
        gmdwProvince: '',
        xsdwProvince: '',
        hxpBms: [],
        beginHfrq: '',
        endHfrq: '',
        beginHzsl: null,
        endHzsl: null,
        hzslDw: '1'
      },
      this.loadDatasource()
    }
  }
}
</script>

<style scoped lang='less'>
  .GmzHqsjfx {
    .headerSearch {
      max-width: 1518px;
      width: 95%;
      margin: auto;
      margin-bottom: 11px;
      margin-top: 30px;
      background-color: white;
      padding: 30px 0 20px 0;
      // border: 1px solid red;
      display: flex;
      align-items: center;
      box-shadow: 0px 1px 27px 3px rgba(0, 0, 0, 0.05);
      border-radius: 5px;
      font-size: 15px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      .sousuo {
        width: 90%;
        margin-left: auto;
        margin-right: auto;
        display: flex;
        justify-content: space-between;
      }
      .el-form-item {
        margin-bottom: 10px;
        margin-right: 30px;
      }
    }
    .tablemes {
      margin: auto;
      width: 90%;
      max-width: 1375px;
      // margin-top: 21px;
      // margin-bottom: 57px;
      // /deep/ .el-table__header {
      //   .el-checkbox {
      //     display: none !important;
      //   }
      // }
      .el-pagination__total {
        margin-left: 8px;
      }
      .el-pagination {
        padding: 10px 0;

        border: 1px solid #ebeef5;
        border-top: 0;
      }
      // .addButton {
      //   color: #fff;
      //   background: #4170ff;
      //   border-radius: 3px;
      //   border-color: #4170ff;
      // }
      .deleteButton {
        background: #ff5721 !important;
        border-color: #ff5721 !important;
      }
      .el-button--warning {
        color: #fff;
        background: #feb800;
        border-radius: 3px;
        border-color: #feb800;
      }
      .el-button--primary {
        color: #fff;
        background: #4170ff;
        border-radius: 3px;
        border-color: #4170ff;
      }
      .el-pager {
        .number {
          background: #4170ff;
          border-color: #4170ff;
        }
      }
    }
  }

  /deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #4170ff !important;
    color: #fff;
  }
  /deep/ .disableheadselection > .cell .el-checkbox__inner {
    display: none !important;
  }
</style>
